import { render, staticRenderFns } from "./PermissionsEditor.vue?vue&type=template&id=00bfcb19"
import script from "./PermissionsEditor.vue?vue&type=script&lang=ts"
export * from "./PermissionsEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports